export default __webpack_public_path__ + "static/media/apple_watch_3.afef1aae.png";